import { c as _c } from "react/compiler-runtime";
import { cn } from "@dc/ui";
import type { FC } from "react";
import type { ScopeIconProps } from "./ScopeIcon.types";
import { CONTAINER_SIZES, ICON_SIZES, SCOPE_ICON_CONFIG } from "./scopeIconConfig";
const NEUTRAL_ICON_COLOR = "var(--color-icon-neutral-onMatch-usual)";
const LIGHT_ICON_COLOR = "white";
const getIconColor = (variant: string, defaultColor: string) => {
  if (variant === "neutral") return NEUTRAL_ICON_COLOR;
  if (variant === "light") return LIGHT_ICON_COLOR;
  return defaultColor;
};
export const ScopeIcon: FC<ScopeIconProps> = t0 => {
  const $ = _c(21);
  const {
    type,
    size: t1,
    showContainer: t2,
    variant: t3,
    className
  } = t0;
  const size = t1 === undefined ? "lg" : t1;
  const showContainer = t2 === undefined ? true : t2;
  const variant = t3 === undefined ? "default" : t3;
  const config = SCOPE_ICON_CONFIG[type];
  const {
    Icon,
    iconColor,
    bgClass
  } = config;
  const iconSize = ICON_SIZES[size];
  let t4;
  if ($[0] !== iconColor || $[1] !== variant) {
    t4 = getIconColor(variant, iconColor);
    $[0] = iconColor;
    $[1] = variant;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  const resolvedIconColor = t4;
  if (!showContainer) {
    let t5;
    if ($[3] !== className) {
      t5 = cn("shrink-0", className);
      $[3] = className;
      $[4] = t5;
    } else {
      t5 = $[4];
    }
    let t6;
    if ($[5] !== Icon || $[6] !== iconSize || $[7] !== resolvedIconColor || $[8] !== t5) {
      t6 = <Icon size={iconSize} color={resolvedIconColor} className={t5} />;
      $[5] = Icon;
      $[6] = iconSize;
      $[7] = resolvedIconColor;
      $[8] = t5;
      $[9] = t6;
    } else {
      t6 = $[9];
    }
    return t6;
  }
  const containerSize = CONTAINER_SIZES[size];
  let t5;
  if ($[10] !== bgClass || $[11] !== className || $[12] !== containerSize) {
    t5 = cn("flex shrink-0 items-center justify-center rounded-md", containerSize, bgClass, className);
    $[10] = bgClass;
    $[11] = className;
    $[12] = containerSize;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  let t6;
  if ($[14] !== Icon || $[15] !== iconSize || $[16] !== resolvedIconColor) {
    t6 = <Icon size={iconSize} color={resolvedIconColor} />;
    $[14] = Icon;
    $[15] = iconSize;
    $[16] = resolvedIconColor;
    $[17] = t6;
  } else {
    t6 = $[17];
  }
  let t7;
  if ($[18] !== t5 || $[19] !== t6) {
    t7 = <div className={t5}>{t6}</div>;
    $[18] = t5;
    $[19] = t6;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  return t7;
};